import { axios, Model, URL } from '@/request'
import { Pos3D } from '@/sdk'
import saveAs from 'file-saver'
import { ref } from 'vue'
import { TemploraryID } from './constant'
import { lang } from '@/lang'
import { params } from '@/hook'
import { resRaw } from '../request/setup'

export type CoordTemp = Model.CoordTemp
export const defaultCoordTempId = '123'
export const coordTemps = ref<CoordTemp[]>([])

export const mergeCoord = async (
  options: Model.MergeTempCoordOption[],
  tempId: string,
  tempName: string,
  type: string,
  name: string
) => {
  const blod = await (axios as any).post(
    URL.mergeTempCoord,
    { options, id: tempId, type, lang, sceneCode: params.m, name },
    {
      responseType: 'blob'
    }
  )
  if (resRaw.headers['filename']) {
    tempName = decodeURIComponent(resRaw.headers['filename'])
  } else {
    tempName = `${tempName}.xls`
  }
  return saveAs(blod, tempName)
}

let backupData: CoordTemp[]
export const getBackups = () => backupData
export const backups = () => {
  backupData = JSON.parse(JSON.stringify(coordTemps.value))
}
export const recovery = () => {
  if (backupData) {
    coordTemps.value = backupData
  }
}

export const requestData = async (type: string, gtype: string) => {
  const res = await axios.post(
    URL.tempCoordList,
    {},
    { paths: { lang: lang, menu: type, type: gtype } }
  )
  coordTemps.value = res || []
}

export const saveCoordTemp = async (temp: CoordTemp) => {
  const res = await axios.post(URL.addTempCoord, {
    ...temp,
    id: undefined
  } as any)
  temp.id = res.id
}

export const deleteMeasure = async (temp: CoordTemp) => {
  await axios.delete(URL.deleteMeasure, { paths: { id: temp.id } })
}

export const storeSave = () => {
  const posts = []
  for (const item of coordTemps.value) {
    if (TemploraryID.is(item.id)) {
      posts.push(saveCoordTemp(item))
    }
  }
  const oldStore = getBackups()
  for (const oldItem of oldStore) {
    if (!coordTemps.value.some(({ id }) => id === oldItem.id)) {
      posts.push(deleteMeasure(oldItem))
    }
  }
  return Promise.all(posts)
}
